<template>
  <div class="flex flex-col relative">
    <!-- Character relationship display -->
    <div class="flex items-center justify-between p-2">
      <div
        class="flex flex-col items-center w-14"
        @click="clickMate(relationship.sourceMate)"
      >
        <div class="w-14">
          <UserAvatar :mate="relationship.sourceMate" />
        </div>
        <div class="text-sm mt-1 line-clamp-1">
          {{ relationship.sourceMate?.name }}
        </div>
      </div>

      <div class="flex flex-col items-center gap-1">
        <template v-if="relationship.reverse">
          <div class="text-sm">
            {{ interactiveStore.getRelationshipTypeName(relationship.reverse) }}
          </div>
          <div class="relative w-40 h-px bg-base-content">
            <i
              class="iconify mingcute--arrow-left-line absolute -left-1 -top-2.5 w-3 text-base-content"
            ></i>
          </div>
        </template>
        <div class="relative w-40 h-px bg-base-content mt-2 mb-1">
          <i
            class="iconify mingcute--arrow-right-line absolute -right-1 -top-2.5 w-3 text-base-content"
          ></i>
        </div>
        <div class="text-sm">
          {{ interactiveStore.getRelationshipTypeName(relationship) }}
        </div>

        <div v-if="isMine" class="flex gap-1">
          <button
            class="btn btn-xs mt-2"
            @click="editRelationship(relationship)"
          >
            <i class="iconify fluent--edit-16-regular w-3"></i>
            {{ $t("Buttons.edit") }}
          </button>
          <button
            class="btn btn-xs mt-2"
            @click="unlinkRelationship(relationship)"
          >
            <i class="iconify mingcute--unlink-line w-3"></i>
            {{ $t("Buttons.unlink") }}
          </button>
        </div>
        <div v-else class="flex gap-1">
          <button
            class="btn btn-xs mt-2"
            @click="editRelationship(relationship)"
          >
            <i class="iconify mingcute--eye-2-line w-3"></i>
            {{ $t("Buttons.view") }}
          </button>
          <button
            class="btn btn-xs mt-2"
            @click="forgetRelationship(relationship)"
          >
            <i class="iconify mingcute--delete-2-line w-3"></i>
            {{ $t("Buttons.forget") }}
          </button>
        </div>
      </div>

      <div
        class="flex flex-col items-center w-14"
        @click="clickMate(relationship.targetMate)"
      >
        <div class="w-14">
          <UserAvatar :mate="relationship.targetMate" />
        </div>
        <div class="text-sm mt-1 line-clamp-1">
          {{ relationship.targetMate?.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MateRelationship, Mate } from "@/types/entity";
import { useRouter } from "vue-router";
import { useInteractive } from "@/stores/interactive";
import { showConfirmDialog, showSuccessToast } from "vant";

const interactiveStore = useInteractive();

const router = useRouter();

const props = defineProps<{
  relationship: MateRelationship;
  isMine: boolean;
}>();

const editRelationship = (relationship: MateRelationship) => {
  console.log(relationship);
  if (props.isMine) {
    router.push({
      name: "relationshipMy",
      query: { id: relationship.id },
    });
  } else {
    router.push({
      name: "relationshipOther",
      query: { id: relationship.id },
    });
  }
};

const unlinkRelationship = (relationship: MateRelationship) => {
  showConfirmDialog({
    title: "确定要解除关系吗？",
    confirmButtonText: "解除",
    cancelButtonText: "取消",
  }).then(async () => {
    const id = relationship.id;
    await interactiveStore.forgetRelationship(id);
    showSuccessToast("解除关系成功");
  });
};

const forgetRelationship = (relationship: MateRelationship) => {
  showConfirmDialog({
    title: "确定要遗忘吗？",
    confirmButtonText: "遗忘",
    cancelButtonText: "取消",
  }).then(async () => {
    await interactiveStore.forgetRelationship(relationship.id);
    showSuccessToast("遗忘成功");
  });
};

const clickMate = (mate?: Mate) => {
  if (!mate) return;
  router.push({
    name: "mateHome",
    params: { uuid: mate.uuid },
  });
};
</script>
